export const QUIZ_LAST_START_TIME = "QUIZ_LAST_START_TIME"